// types
import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {
  account: {
    data: {},
    userId: null,
    company_id: null,
  },
  selectedJob: null, 
  selectedCandidates: [],
  appAlert: {
    show: false,
    alertType: 'info',
    alertMessage: ''
  },
};

// ==============================|| DATA STORE ||============================== //

const appRed = createSlice({
  name: "app-reducer",
  initialState,
  reducers: {
    setAccount(state, action) {
      state.account = {
        ...state.account,
        data: action.payload.data,
        // Include userId,companyId in account state
        userId: action.payload.userId,
        company_id: action.payload.company_id,
      };
    },
    selectJob(state, action) {
      state.selectedJob = action.payload; // Update selectedJob in state
      state.selectedCandidates = []; // Clear selectedCandidates in state
    },
    // Select candidates Reducer . 
    addCandidate(state, action) {
      // console.log("State before adding candidate:", state);
      // console.log("Action payload:", action.payload);
      const { ResumeId } = action.payload;
    
      // Ensure selectedCandidates is defined and avoid duplicates
      state.selectedCandidates = state.selectedCandidates || [];
      if (!state.selectedCandidates.find((c) => c.ResumeId === ResumeId)) {
        state.selectedCandidates.push(action.payload);
      }
    },
    
    removeCandidate(state, action) {
      const { ResumeId } = action.payload;
      state.selectedCandidates = state.selectedCandidates.filter(
        (c) => c.ResumeId !== ResumeId
      );
    },
    clearCandidates(state) {
      state.selectedCandidates = [];
    },

    showAppAlert(state, action) {
      state.appAlert = {
        show: action.payload.show,
        alertType: action.payload.alertType,
        alertMessage: action.payload.alertMessage
      };
    },
  },
});

export default appRed.reducer;

export const {
  setAccount,
  selectJob,
  addCandidate,
  removeCandidate,
  clearCandidates,
  showAppAlert,
} = appRed.actions;
